import { render, staticRenderFns } from "./ServiceListDialog.vue?vue&type=template&id=2c58cc6a"
import script from "./ServiceListDialog.vue?vue&type=script&lang=js"
export * from "./ServiceListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports